import { contactData } from '@/mocks/home';

export default function SectionContact() {
  return (
    <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-background-100" style={{ scrollMarginTop: '4rem' }}>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="font-heading font-bold text-xl md:text-2xl lg:text-3xl text-foreground-950 mb-2">
            投稿爆料
          </h2>
          <p className="text-base md:text-lg text-foreground-600 font-heading">{contactData.subtitle}</p>
        </div>
        <div className="bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70 text-center">
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">{contactData.description}</p>
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 mb-8">
            {contactData.tips.map((tip) => (
              <div key={tip} className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-shield-check-line text-primary-500 text-lg"></i>
                <span>{tip}</span>
              </div>
            ))}
          </div>
          <a
            href={`mailto:${contactData.email}`}
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-send-line"></i>
            发送爆料至 {contactData.email}
          </a>
        </div>
      </div>
    </section>
  );
}